<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="display:none" aria-hidden="true">
<!-- 线性图标 -->
<symbol id="i-grid" viewBox="0 0 24 24"><rect x="3.4" y="3.4" width="7.2" height="7.2" rx="2.2"/><rect x="13.4" y="3.4" width="7.2" height="7.2" rx="2.2"/><rect x="3.4" y="13.4" width="7.2" height="7.2" rx="2.2"/><rect x="13.4" y="13.4" width="7.2" height="7.2" rx="2.2"/></symbol>
<symbol id="i-card" viewBox="0 0 24 24"><rect x="2.6" y="5.6" width="18.8" height="12.8" rx="2.6"/><path d="M2.6 10h18.8"/><path d="M6.2 14.6h4"/></symbol>
<symbol id="i-plane" viewBox="0 0 24 24"><path d="M20.8 4.2L3.4 11.1l6.8 2.9 2.9 6.8z"/><path d="M20.8 4.2l-10.6 9.8"/></symbol>
<symbol id="i-box" viewBox="0 0 24 24"><path d="M12 3.2l8 4v9.6l-8 4-8-4V7.2z"/><path d="M4 7.2l8 4 8-4"/><path d="M12 11.2v9.6"/></symbol>
<symbol id="i-user" viewBox="0 0 24 24"><circle cx="12" cy="8.2" r="3.6"/><path d="M4.8 20.6a7.2 7.2 0 0 1 14.4 0"/></symbol>
<symbol id="i-search" viewBox="0 0 24 24"><circle cx="10.6" cy="10.6" r="6.4"/><path d="M15.4 15.4L20.8 20.8"/></symbol>
<symbol id="i-trend" viewBox="0 0 24 24"><path d="M3.2 17.2l5.6-5.6 3.8 3.8 8-8"/><path d="M15.6 7.4h5v5"/></symbol>
<symbol id="i-sparkle" viewBox="0 0 24 24"><path d="M12 3.4l2.2 5.4 5.4 2.2-5.4 2.2L12 18.6l-2.2-5.4L4.4 11l5.4-2.2z"/></symbol>
<symbol id="i-browser" viewBox="0 0 24 24"><rect x="2.8" y="4.2" width="18.4" height="15.6" rx="2.6"/><path d="M2.8 9h18.4"/><path d="M9.5 13.6l4.6 2.1-2 1-1 2z"/></symbol>
<symbol id="i-rocket" viewBox="0 0 24 24"><path d="M13.6 4.4c3.2-1.6 6-1 6-1s.6 2.8-1 6c-1.2 2.4-3.6 4.4-5.6 5.4l-4.8-4.8c1-2 3-4.4 5.4-5.6z"/><path d="M9.2 15.2L4 20.4"/><path d="M7.6 9.6l-3 .8 1.4 1.4"/><path d="M14.4 16.4l-.8 3-1.4-1.4"/></symbol>
<symbol id="i-globe" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.8"/><path d="M3.4 12h17.2"/><ellipse cx="12" cy="12" rx="4.1" ry="8.8"/></symbol>
<symbol id="i-truck" viewBox="0 0 24 24"><path d="M2.6 7.4h10.2v9.2H2.6z"/><path d="M12.8 10.6h3.7l3.9 3.7v2.3h-7.6z"/><circle cx="6.6" cy="18.4" r="1.7"/><circle cx="17" cy="18.4" r="1.7"/></symbol>
<symbol id="i-chat" viewBox="0 0 24 24"><rect x="3.2" y="4.4" width="17.6" height="12" rx="3"/><path d="M8.4 16.4v3.8l4.2-3.8"/><path d="M8 10.4h8M8 13.2h5"/></symbol>
<symbol id="i-money" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M12 7.2v9.6M14.8 9.4c-.6-1-1.6-1.5-2.8-1.5-1.6 0-2.7.9-2.7 2.2 0 1.3 1.1 1.9 2.7 2.2 1.7.3 2.9.9 2.9 2.3 0 1.3-1.2 2.2-2.9 2.2-1.4 0-2.4-.5-3.1-1.6"/></symbol>
<symbol id="i-gear" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3.3"/><path d="M12 3v2.6M12 18.4V21M4.2 7.5l2.25 1.3M17.55 15.2l2.25 1.3M4.2 16.5l2.25-1.3M17.55 8.8l2.25-1.3"/></symbol>
<symbol id="i-tee" viewBox="0 0 24 24"><path d="M9 3.6L4.2 6.1l1.5 3.1 2.1-1v11.2h8.4V8.2l2.1 1 1.5-3.1L14.9 3.6a3.4 3.4 0 0 1-5.9 0z"/></symbol>
<symbol id="i-bag" viewBox="0 0 24 24"><path d="M5.6 8.6h12.8l1.1 11.8H4.5z"/><path d="M9 8.6V6.4a3 3 0 0 1 6 0v2.2"/></symbol>
<symbol id="i-headphone" viewBox="0 0 24 24"><path d="M4.4 15.2v-2.6a7.6 7.6 0 0 1 15.2 0v2.6"/><rect x="2.4" y="14" width="3.9" height="6.6" rx="1.95"/><rect x="17.7" y="14" width="3.9" height="6.6" rx="1.95"/></symbol>
<symbol id="i-watch" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.5"/><path d="M9.7 7.6l.5-3.8h3.6l.5 3.8M9.7 16.4l.5 3.8h3.6l.5-3.8"/></symbol>
<symbol id="i-clock" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M12 7.4V12l3.2 2"/></symbol>
<symbol id="i-layers" viewBox="0 0 24 24"><path d="M12 3.2l8.4 4.2-8.4 4.2L3.6 7.4z"/><path d="M3.6 12.2l8.4 4.2 8.4-4.2"/><path d="M3.6 16.6l8.4 4.2 8.4-4.2"/></symbol>
<symbol id="i-horn" viewBox="0 0 24 24"><path d="M3.4 9.6h3.4l7.4-4.4v13.6l-7.4-4.4H3.4z"/><path d="M17.6 8.4a5.2 5.2 0 0 1 0 7.2"/></symbol>
<symbol id="i-link" viewBox="0 0 24 24"><path d="M10.4 13.6a3.6 3.6 0 0 0 5.1 0l2.6-2.6a3.6 3.6 0 0 0-5.1-5.1l-1.1 1.1"/><path d="M13.6 10.4a3.6 3.6 0 0 0-5.1 0L5.9 13a3.6 3.6 0 0 0 5.1 5.1l1.1-1.1"/></symbol>
<symbol id="i-factory" viewBox="0 0 24 24"><path d="M3.4 20.4V9.6l5 3.2V9.6l5 3.2V9.6l7.2 4.2v6.6z"/><path d="M2.4 20.4h19.2"/></symbol>
<symbol id="i-warehouse" viewBox="0 0 24 24"><path d="M3.2 20.4V9.2L12 4.6l8.8 4.6v11.2"/><path d="M7.6 20.4v-6.2h8.8v6.2"/><path d="M2.4 20.4h19.2"/></symbol>
<symbol id="i-store" viewBox="0 0 24 24"><path d="M4.2 9.6V20.2h15.6V9.6"/><path d="M3 9.6l2-5.2h14l2 5.2z"/><path d="M9.4 20.2v-5.6h5.2v5.6"/></symbol>
<symbol id="i-shield" viewBox="0 0 24 24"><path d="M12 3l7.4 3v5.4c0 4.6-3.1 7.9-7.4 9.6-4.3-1.7-7.4-5-7.4-9.6V6z"/><path d="M8.8 11.9l2.3 2.3 4.2-4.4"/></symbol>
<symbol id="i-pin" viewBox="0 0 24 24"><path d="M12 20.8s6.9-6.1 6.9-10.8a6.9 6.9 0 1 0-13.8 0c0 4.7 6.9 10.8 6.9 10.8z"/><circle cx="12" cy="9.9" r="2.5"/></symbol>
<symbol id="i-percent" viewBox="0 0 24 24"><path d="M18.4 5.6L5.6 18.4"/><circle cx="7.6" cy="7.6" r="2.4"/><circle cx="16.4" cy="16.4" r="2.4"/></symbol>

<!-- 通用动作与内容图标 -->
<symbol id="i-check" viewBox="0 0 24 24"><path d="M4.8 12.6l4.6 4.6L19.2 7.4"/></symbol>
<symbol id="i-arrow" viewBox="0 0 24 24"><path d="M4.5 12h14.6M13.4 6.3l5.7 5.7-5.7 5.7"/></symbol>
<symbol id="i-close" viewBox="0 0 24 24"><path d="M6.4 6.4l11.2 11.2M17.6 6.4L6.4 17.6"/></symbol>
<symbol id="i-quote" viewBox="0 0 24 24"><path d="M9.4 6.6c-3 1.6-4.6 4.2-4.6 7.6 0 2 1.2 3.4 3 3.4 1.6 0 2.8-1.2 2.8-2.9 0-1.6-1.1-2.7-2.6-2.7-.3 0-.6 0-.8.1.3-1.5 1.3-2.7 2.9-3.7zM18.2 6.6c-3 1.6-4.6 4.2-4.6 7.6 0 2 1.2 3.4 3 3.4 1.6 0 2.8-1.2 2.8-2.9 0-1.6-1.1-2.7-2.6-2.7-.3 0-.6 0-.8.1.3-1.5 1.3-2.7 2.9-3.7z"/></symbol>
<symbol id="i-book" viewBox="0 0 24 24"><path d="M4.5 5.2c2.6-.9 5-.6 7.5 1.1v12c-2.5-1.7-4.9-2-7.5-1.1z"/><path d="M19.5 5.2c-2.6-.9-5-.6-7.5 1.1v12c2.5-1.7 4.9-2 7.5-1.1z"/></symbol>
<symbol id="i-mail" viewBox="0 0 24 24"><rect x="3.2" y="5.6" width="17.6" height="12.8" rx="2.4"/><path d="M3.8 7l8.2 6 8.2-6"/></symbol>
<symbol id="i-play" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.6"/><path d="M10.2 8.8l5.2 3.2-5.2 3.2z"/></symbol>
<symbol id="i-bolt" viewBox="0 0 24 24"><path d="M13.2 3.2L5.6 13.4h5.2l-.9 7.4 7.7-10.2h-5.3z"/></symbol>
<symbol id="i-star" viewBox="0 0 24 24"><path d="M12 3.6l2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.8z"/></symbol>
<symbol id="i-route" viewBox="0 0 24 24"><circle cx="6" cy="6.6" r="2.4"/><circle cx="18" cy="17.4" r="2.4"/><path d="M8.4 6.6h5.2a3 3 0 0 1 0 6h-3.2a3 3 0 0 0 0 6h5.2"/></symbol>
<symbol id="i-customs" viewBox="0 0 24 24"><rect x="3.6" y="9.2" width="16.8" height="11.2" rx="2"/><path d="M3.6 13.4h16.8M12 9.2V4.4M8.4 4.4h7.2"/></symbol>
<symbol id="i-wallet" viewBox="0 0 24 24"><rect x="3.2" y="6.4" width="17.6" height="12.4" rx="2.6"/><path d="M3.2 10.6h17.6M16.4 15h2"/></symbol>
<symbol id="i-bank" viewBox="0 0 24 24"><path d="M3.6 9.4L12 4.6l8.4 4.8z"/><path d="M6.2 9.4v8M10 9.4v8M14 9.4v8M17.8 9.4v8M3.6 17.4h16.8"/></symbol>
<symbol id="i-refresh" viewBox="0 0 24 24"><path d="M19.4 12a7.4 7.4 0 1 1-2.4-5.4"/><path d="M19.8 4.6v4.2h-4.2"/></symbol>
<symbol id="i-lock" viewBox="0 0 24 24"><rect x="5" y="10.4" width="14" height="9.8" rx="2.4"/><path d="M8.4 10.4V7.8a3.6 3.6 0 0 1 7.2 0v2.6"/></symbol>
<symbol id="i-chart" viewBox="0 0 24 24"><path d="M4 19.4h16"/><path d="M7.2 19.4v-6M12 19.4V6.6M16.8 19.4v-9"/></symbol>
<symbol id="i-cursor" viewBox="0 0 24 24"><path d="M6 4.4l12.4 7.2-5.4 1.4-1.9 5.5z"/></symbol>
<symbol id="i-life" viewBox="0 0 24 24"><path d="M4.6 15.4v-3a7.4 7.4 0 0 1 14.8 0v3"/><rect x="2.8" y="13.6" width="4" height="6" rx="2"/><rect x="17.2" y="13.6" width="4" height="6" rx="2"/><path d="M19.4 19.6v.6a2.6 2.6 0 0 1-2.6 2.6H13"/></symbol>
<symbol id="i-tag" viewBox="0 0 24 24"><path d="M4.4 11.2V4.6h6.6l8.6 8.6-6.4 6.4z"/><circle cx="8.4" cy="8.4" r="1.3"/></symbol>
<symbol id="i-doc" viewBox="0 0 24 24"><path d="M13.6 3.6H6.8a1.8 1.8 0 0 0-1.8 1.8v13.2a1.8 1.8 0 0 0 1.8 1.8h10.4a1.8 1.8 0 0 0 1.8-1.8V8.4z"/><path d="M13.4 3.6v4.8h4.8M8.6 13h6.8M8.6 16.4h4.6"/></symbol>
<symbol id="i-video" viewBox="0 0 24 24"><rect x="2.8" y="6.4" width="12.4" height="11.2" rx="2.2"/><path d="M15.2 10.4l5.4-3v9.2l-5.4-3z"/></symbol>
<symbol id="i-sliders" viewBox="0 0 24 24"><path d="M4 8.4h10M18 8.4h2M4 15.6h4M12 15.6h8"/><circle cx="16" cy="8.4" r="2"/><circle cx="10" cy="15.6" r="2"/></symbol>
<symbol id="i-palette" viewBox="0 0 24 24"><path d="M12 3.4a8.6 8.6 0 0 0 0 17.2c1.3 0 2-.9 2-1.9 0-1.5 1-2.2 2.3-2.2h1.4a2.9 2.9 0 0 0 2.9-2.9c0-5.7-3.8-10.2-8.6-10.2z"/><circle cx="8.2" cy="10.2" r="1.2"/><circle cx="12" cy="7.6" r="1.2"/><circle cx="15.8" cy="10.2" r="1.2"/></symbol>
<symbol id="i-code" viewBox="0 0 24 24"><path d="M8.4 7.6L3.6 12l4.8 4.4M15.6 7.6L20.4 12l-4.8 4.4M13.6 4.8l-3.2 14.4"/></symbol>

<!-- 社媒（实心） -->
<symbol id="i-fb" viewBox="0 0 24 24"><path fill="currentColor" stroke="none" d="M13.6 21v-7.6h2.6l.4-3h-3V8.5c0-.9.2-1.5 1.5-1.5h1.6V4.3c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2.1H7.6v3h2.7V21z"/></symbol>
<symbol id="i-ig" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="5" fill="none" stroke="currentColor" stroke-width="1.9"/><circle cx="12" cy="12" r="3.9" fill="none" stroke="currentColor" stroke-width="1.9"/><circle cx="17" cy="7" r="1.2" fill="currentColor" stroke="none"/></symbol>
<symbol id="i-x" viewBox="0 0 24 24"><path fill="currentColor" stroke="none" d="M4 4h3.9l4.3 5.9L17.4 4h2.2l-6 6.9L20 20h-3.9l-4.6-6.3L6.3 20H4.1l6.3-7.3z"/></symbol>
<symbol id="i-yt" viewBox="0 0 24 24"><rect x="2.6" y="6" width="18.8" height="12" rx="3.6" fill="none" stroke="currentColor" stroke-width="1.9"/><path fill="currentColor" stroke="none" d="M10.4 9.2l4.6 2.8-4.6 2.8z"/></symbol>
<symbol id="i-tk" viewBox="0 0 24 24"><path fill="currentColor" stroke="none" d="M14.2 3h2.5c.2 1.7 1.2 3 2.9 3.4v2.6c-1.1 0-2.1-.3-3-.9v5.9c0 3.4-2.4 5.6-5.4 5.6-3 0-5.2-2.1-5.2-4.9 0-3 2.5-5.1 5.5-4.9v2.7c-1.6-.3-2.9.6-2.9 2.2 0 1.3 1 2.3 2.4 2.3 1.5 0 2.5-1 2.5-2.9z"/></symbol>


<!-- ============================================================
     小 Tao · 品牌吉祥物
     一个紫色小机器人，头上天线是 Taoify 的 T。
     全部为线描 + 淡紫填充，与页面图标系统同一套笔触。
     用法：<svg class="mascot"><use href="#m-hi"/></svg>
     ============================================================ -->

<!-- 基础体：头 + 身体 + 脚 + 笑眼 + 左手，其余姿态复用 -->
<symbol id="m-base" viewBox="0 0 168 180">
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M84 21V10" fill="none"/>
    <circle cx="84" cy="7" r="5.2" fill="#C9B6FF"/>
    <path d="M70 152v10M98 152v10" stroke-width="9" fill="none"/>
    <path d="M56 118c-8 5-12 13-12 21" stroke-width="9.5" fill="none"/>
    <rect x="56" y="110" width="56" height="46" rx="21" fill="#F3EDFF"/>
    <path d="M84 123v16M77 129l7-6 7 6" stroke="#7331FF" fill="none"/>
    <rect x="32" y="22" width="104" height="88" rx="43" fill="#F3EDFF"/>
    <circle cx="31" cy="64" r="7" fill="#F3EDFF"/>
    <circle cx="137" cy="64" r="7" fill="#F3EDFF"/>
    <ellipse cx="49" cy="74" rx="9" ry="5.4" fill="#FFB2C8" stroke="none" opacity=".55"/>
    <ellipse cx="119" cy="74" rx="9" ry="5.4" fill="#FFB2C8" stroke="none" opacity=".55"/>
    <path d="M60 58q7-8 14 0" fill="none"/>
    <path d="M94 58q7-8 14 0" fill="none"/>
    <path d="M77 74q7 7 14 0" fill="none"/>
  </g>
</symbol>

<!-- 1 招手：欢迎、首屏引导 -->
<symbol id="m-hi" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M110 118c16-2 28-12 34-27" stroke-width="9.5"/>
    <circle cx="146" cy="87" r="8.5" fill="#F3EDFF" stroke-width="3"/>
    <path d="M158 74q6-6 7-13" stroke-width="2.8"/>
    <path d="M162 83q6-4 8-10" stroke-width="2.8"/>
  </g>
</symbol>

<!-- 2 指路：引导看下一块内容 -->
<symbol id="m-point" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M112 122c14 1 26-3 36-11" stroke-width="9.5"/>
    <circle cx="151" cy="109" r="8.5" fill="#F3EDFF" stroke-width="3"/>
  </g>
</symbol>

<!-- 3 思考：FAQ、复杂概念 -->
<symbol id="m-think" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M112 112c9 8 8 18-1 22" stroke-width="9.5"/>
    <circle cx="107" cy="136" r="8" fill="#F3EDFF" stroke-width="3"/>
  </g>
  <g fill="#7331FF">
    <circle cx="129" cy="36" r="3.4"/>
    <circle cx="139" cy="28" r="4.4"/>
    <circle cx="151" cy="19" r="5.6"/>
  </g>
</symbol>

<!-- 4 点赞：CTA、结果确认 -->
<symbol id="m-ok" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M112 120c11 0 18-8 18-18" stroke-width="9.5"/>
    <circle cx="132" cy="106" r="9" fill="#F3EDFF" stroke-width="3"/>
    <path d="M132 99v-11" stroke-width="5" stroke-linecap="round"/>
  </g>
</symbol>

<!-- 5 搬箱子：物流、发货 -->
<symbol id="m-box" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
    <rect x="62" y="126" width="44" height="32" rx="5" fill="#E6D9FF"/>
    <path d="M62 136h44M84 126v32" fill="none" stroke-dasharray="5 4" opacity=".55"/>
    <path d="M56 116c-4 9-2 16 6 19" stroke-width="9.5" fill="none"/>
    <path d="M112 116c4 9 2 16-6 19" stroke-width="9.5" fill="none"/>
  </g>
</symbol>

<!-- 6 抱金币：收款、结算 -->
<symbol id="m-coin" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#D99A00" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="84" cy="139" r="19" fill="#FFD98A"/>
    <path d="M84 130v18M89 133c-1-2-3-3-5-3-3 0-5 2-5 4s2 3 5 4 5 2 5 4-2 4-5 4c-2 0-4-1-5-3" fill="none" stroke="#B87C00" stroke-width="2.6"/>
    <path d="M56 122c-5 8-2 16 6 20" stroke="#6E4BE0" stroke-width="8.5" fill="none"/>
    <path d="M112 122c5 8 2 16-6 20" stroke="#6E4BE0" stroke-width="8.5" fill="none"/>
  </g>
</symbol>

<!-- 7 敲电脑：建站、后台操作 -->
<symbol id="m-lap" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
    <rect x="50" y="120" width="68" height="34" rx="4" fill="#2A2350" stroke="#1F1A3D"/>
    <path d="M58 128h26M58 136h38" stroke="#8E7BFF" stroke-width="2.6"/>
    <rect x="44" y="154" width="80" height="7" rx="3.5" fill="#E6D9FF"/>
  </g>
</symbol>

<!-- 8 欢呼：成功、案例 -->
<symbol id="m-yay" viewBox="0 0 168 180">
  <use href="#m-base"/>
  <g stroke="#6E4BE0" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d="M56 120c-9-6-14-16-14-27" stroke-width="8.5"/>
    <circle cx="41" cy="88" r="7.5" fill="#F3EDFF" stroke-width="3"/>
    <path d="M112 120c9-6 14-16 14-27" stroke-width="8.5"/>
    <circle cx="127" cy="88" r="7.5" fill="#F3EDFF" stroke-width="3"/>
  </g>
  <g fill="#7331FF">
    <path d="M26 40l2.4 6.6L35 49l-6.6 2.4L26 58l-2.4-6.6L17 49l6.6-2.4z"/>
    <path d="M143 26l1.8 5L150 33l-5.2 1.8L143 40l-1.8-5.2L136 33l5.2-2z"/>
  </g>
</symbol>

</svg>
</template>

<script>
export default {
  name: 'WebsiteSprite',
}
</script>
